<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="page_2"></a><strong>Also by Juliet Marillier</strong></p>
<p class="centeraa">T<span class="small">HE</span> S<span class="small">EVENWATERS</span> T<span class="small">RILOGY</span></p>
<p class="centerab"><em>Daughter of the Forest</em></p>
<p class="centerab"><em>Son of the Shadows</em></p>
<p class="centerab"><em>Child of the Prophecy</em></p>
<p class="centeraaa"><em>Wolfskin</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?1f7cf5e2